import React, { useContext, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Steps,
  Form,
  Alert, Spin,
} from "antd";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import {showSuccessMessage} from "../../utils/notification.util";
import BasicInfo from "./Steps/BasicInfo";
import ViolenceInformation from "./Steps/ViolenceInformation";
import CurrentImpact from "./Steps/CurrentImpact";
import ConcordanceCard from "./Steps/ConcordanceCards";
import Acknowledgement from "./Steps/Acknowledgement";
import Feedback from "./Steps/Feedback";
import { Review } from "./Steps/Review";
import { createInterview, fetchInterviewByUUID, updateInterview } from "../../services/interview.service";
import { prepareFormData, preparePayload } from "./util";
import { fetchCampaignByUUID } from "../../services/campaign.service";
import { GlobalContext } from "../../context/GlobalContext";
import {noAccess} from "../../utils/common";
import {roleValues} from "../../config/roles";
import IndividualIRMPackage from "./Steps/IndividualIRMPackage";
import {getStateNameById} from "../Campaign/utils";

const { Step } = Steps;

export default function InterviewForm() {
  const [searchParams] = useSearchParams();
  const currentTab = searchParams.get('tab');
  const { setBreadCrumb, user } = useContext(GlobalContext);
  const { campaignUUID, uuid } = useParams();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [campaign, setCampaign] = useState({id: ''});
  const [formData, setFormData] = useState({});
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if(!(user?.role === roleValues.admin || user?.role === roleValues.dataProtectionOfficer || user?.role === roleValues.projectCoordinator)) {
      noAccess();
    }
    if (uuid) {
      fetchInterviewByUUID(uuid)
      .then((response) => {
        const apiResponse = response.data;
        form.setFieldsValue(prepareFormData(apiResponse))
      })
      .catch((error) => {})
          .finally(() => {setLoading(false)});
    }
    if(campaignUUID) {
      fetchCampaignByUUID(campaignUUID)
      .then((response) => {
        setCampaign(response.data);
        if (uuid) {
          setBreadCrumb([
            {
              title: 'Survivor Identification',
              link: `/location`,
            },
            {
              title: getStateNameById(response.data.state) + ', ' + response.data.district,
              link: `/location/detail/${campaignUUID}`,
            },
            {
              title: 'Survivor',
              link: `/location/${campaignUUID}/interview/detail/${uuid}`,
            },
            {
              title:  'Edit',
              link: currentTab ? `/location/${campaignUUID}/interview/edit/${uuid}?tab=${currentTab}` : `/location/${campaignUUID}/interview/edit/${uuid}`,
            },
          ])
        } else {
          setBreadCrumb([
            {
              title: 'Survivor Identification',
              link: `/location`,
            },
            {
              title: getStateNameById(response.data.state) + ', ' + response.data.district,
              link: `/location/detail/${campaignUUID}`,
            },
            {
              title:  'New Survivor',
              link: `/location/${campaignUUID}/interview/create`,
            },
          ])
        }
      })
      .catch((error) => {})
          .finally(() => {setLoading(false)});
    }
  }, []);
  let steps = [
    {
      title: 'Basic Information',
      content: (
        <>
          <BasicInfo form={form} />
        </>
      ),
    },
    {
      title: 'Current Impact',
      content: (
        <>
          <CurrentImpact />
        </>
      ),
    },
    {
      title: 'Concordance Cards',
      content: (
        <>
          <ConcordanceCard />
        </>
      ),
    },
    {
      title: 'Acknowledgement',
      content: (
        <>
          <Acknowledgement />
        </>
      ),
    },
    {
      title: 'Observation',
      content: (
        <>
          <Feedback />
        </>
      ),
    },
    {
      title: 'Violence Information',
      content: (
        <>
          <ViolenceInformation form={form}/>
        </>
      ),
    },
    {
      title: 'Review',
      content: (
        <>
          <Alert
            message="Review the Information Below. "
            description="If you need to make any changes, please click on the 'Back' button to go back to the relevant section. If you are satisfied with the information, please click on the 'Next' button to submit the feedback."
            type="error"
          />
          <Review formData={formData}
                  maskThisFullName={() => console.log("masked")}
                  maskThisPhone={() => console.log("masked")}
                  mode={"update"}
          />
        </>
      ),
    },

  ];
  if(currentTab === 'basicInfo') {
    steps = [
      {
        title: 'Basic Information',
        content: (
            <>
              <BasicInfo form={form} />
            </>
        ),
      },
    ]
  }
  if(currentTab === 'currentImpact') {
    steps = [
      {
        title: 'Current Impact',
        content: (
            <>
              <CurrentImpact />
            </>
        ),
      },
    ]
  }
  if(currentTab === 'concordanceCard') {
    steps = [
      {
        title: 'Concordance Cards',
        content: (
            <>
              <ConcordanceCard />
            </>
        ),
      },
    ]
  }
  if(currentTab === 'acknowledgement') {
    steps = [
      {
        title: 'Acknowledgement',
        content: (
            <>
              <Acknowledgement />
            </>
        ),
      }
    ]
  }
  if(currentTab === 'observation') {
    steps = [
      {
        title: 'Observation',
        content: (
            <>
              <Feedback />
            </>
        ),
      },
    ]
  }
  if(currentTab === 'violenceInformation') {
    steps = [
      {
        title: 'Violence Information',
        content: (
            <>
              <ViolenceInformation form={form} />
            </>
        ),
      },
    ]
  }
  if(currentTab === 'irmPackage') {
    steps = [
      {
        title: 'Individual IRM Package',
        content: (
            <>
              <IndividualIRMPackage />
            </>
        ),
      },
    ]
  }


  const next = () => {
    form.validateFields().then(values => {
      setFormData(prevData => ({ ...prevData, ...values }));
      setCurrentStep(currentStep + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }).catch((error) => {
      console.error('Validation failed:', error);
    });;
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handleSaveDraft = () => {
    setLoading(true);
    form.validateFields().then(values => {
      setFormData(prevData => ({ ...prevData, ...values }));
      setTimeout(() => form.submit(), 500);
    }).catch((error) => {
      console.error('Validation failed:', error);
    }).finally(() => {
      setLoading(false);
    });
  }
  const onFinish = () => {
    setIsSubmitting(true);
    setLoading(true);
    setTimeout(() => {
      setIsSubmitting(false);
    }, 10000);
    const payload = preparePayload(campaign.id, formData);
    console.log('Form Data:', payload);
    if (uuid) {
      updateInterview(uuid, payload)
      .then((response) => {
        showSuccessMessage(`Details updated successfully!`);
        let str = '';
        if(currentTab) str = '?section='+currentTab;
        navigate(`/location/${campaignUUID}/interview/detail/${uuid}${str}`);
      })
      .catch((error) => {console.log(error)})
          .finally(() => {setLoading(false)});
    } else {
      createInterview(payload)
      .then((response) => {
        showSuccessMessage(`Details of ${payload.basicInfo.fullName} created successfully!`);
        navigate(`/location/${campaignUUID}/interview/detail/${response.data.interview.uuid}`);
        // navigate(`/location/detail/${campaignUUID}`);
      })
      .catch((error) => {console.log(error)})
          .finally(() => {setLoading(false)});
    }
  };

  return (
      <Spin spinning={loading}>
        <div>
          <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            {steps.length > 1 &&
              <Steps current={currentStep}>
                {steps.map(item => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
            }
          </Col>
          </Row>
          <Row gutter={[24, 0]} style={{marginTop: '20px'}}>
          <Col xs={24} xl={24}>
          <Card
                  title={steps.length === 1 && <h3>{steps[0].title}</h3>}
                  bordered={false}
                  className="criclebox tablespace mb-24"
                  style={{padding: '20px'}}
                >
            <br/>
          <Form form={form}
            layout="vertical"
            onFinish={onFinish}
            key={JSON.stringify(formData)}
            initialValues={formData}>
            <div style={{padding:'24px'}}>
            {steps[currentStep].content}
            </div>
            <div style={{ marginTop: 24 }}>
            {currentStep > 0 && (
                <Button style={{ marginRight: 8 }} onClick={prev}>
                  Previous
                </Button>
              )}
              {currentStep < steps.length - 1 && (
                <Button type="primary" onClick={next}>
                  Next
                </Button>
              )}
              {/* {currentStep === steps.length - 1 && (
                <Button htmlType="button" style={{ marginRight: 8 }} onClick={() => handleSaveDraft()} disabled={isSubmitting}>
                  Save as Draft
                </Button>
              )} */}
              {currentStep === steps.length - 1 && !currentTab && (
                <Button type="primary" htmlType="submit" disabled={isSubmitting}>
                  Save and Submit
                </Button>
              )}
              {currentTab && <Button type="primary" htmlType="button" onClick={() => handleSaveDraft()} disabled={isSubmitting}>
                Update
              </Button>}

            </div>
          </Form>
          </Card>
          </Col>
          </Row>
        </div>
      </Spin>
  );
}
